export default __webpack_public_path__ + "static/media/caleb-02-icon.24a8de72.svg";